import { CONFERENCE_FAILED, CONFERENCE_LEFT, CONFERENCE_WILL_JOIN, CONFERENCE_WILL_LEAVE, KICKED_OUT, SET_PASSWORD, STOP_WAIT_FOR_OWNER } from '../base/conference';

import { SET_KNOCKING_STATE } from '../lobby/actionTypes'

import { UPDATE_ADMIN_AVAILABILITY } from './actionTypes';

export function RPC_STATE(state) {
    return {
        ...state,
        error: {}, left: false, password_changed: false, loading: false, isAdminExist: false, password: ''
    };
}

export function RPC_PrejoinReducer(state, action) {
    switch (action.type) {
        case SET_PASSWORD: {
            return {
                ...state,
                error: {},
                loading: true,
                password_changed: false,
                password: action.password
            }
        }
        case SET_KNOCKING_STATE: {
            return {
                ...state,
                error: {
                    name: 'conference.connectionError.membersOnly'
                }
            }
        }
        case CONFERENCE_WILL_JOIN: {
            return {
                ...state,
                error: {},
                loading: true
            }
        }
        case "ASKING_PASSWORD_CHANGED": {
            return {
                ...state,
                error: {},
                loading: true,
                password_changed: true
            }
        }
        case CONFERENCE_WILL_LEAVE: {
            return {
                ...state,
                left: true
            }
        }
        case KICKED_OUT: {
            return {
                ...state,
                left: true
            }
        }
        case CONFERENCE_FAILED: {
            return {
                ...state,
                error: action.error,
                loading: false
            }
        }
        case UPDATE_ADMIN_AVAILABILITY: {
            return {
                ...state,
                isAdminExist:action.value
            }
        }
    }
    return state;
}